import Types from "./Types";

const INITIAL_STATE = {
  allGroups: [],
  groups: [],
  performanceGroups: [],
  group: {},
  isLoading: false,
  count: "",
};

export default function studentGroups(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.GET_GROUPS_STUDENT_SUCCESS: {
      return {
        ...state,
        groups: payload.data,
        count: payload.data.length,
      };
    }

    case Types.GROUPS_LOADING: {
      return {
        ...state,
        isLoading: payload,
      };
    }

    default: {
      return state;
    }
  }
}
